import './PageContact.scss';
import { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const PageContact = () => {
    const {theme, darkTheme, lightTheme} = useContext(ThemeContext);
    const [formEnviado, setFormEnviado] = useState(false);

    useEffect(() => {
        if(theme) {
            lightTheme();
        } else {
            darkTheme();
        }
    }, [theme, lightTheme, darkTheme])


    return(
        <div className='page-contact'>
            <div className='page-contact__subtitle text'>
                - contacto -
            </div>
            <div className='page-contact__title'>
                <h1>Gracias por contactarme</h1>
            </div>
            <div className='page-contact__form'>
                <Formik
                    //valores iniciales
                    initialValues={{
                        name:'',
                        email:'',
                        tel:'',
                        subject:'',
                        message:''
                    }}
                    //para validar el formulario
                    validate={(valores) => {
                        let errores = {};
                        //validacion para el nombre
                        if(!valores.name) {
                            errores.name = 'Por favor ingresa un nombre';
                        } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(valores.name)) {
                            errores.name = 'El nombre solo puede contener letras y espacios.'
                        }
                        //validacion para el correo
                        if(!valores.email) {
                            errores.email = 'Por favor ingresa un correo';
                        } else if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(valores.email)) {
                            errores.email = 'El correo solo puede tener letras, numeros, puntos, guiones, y guion bajo.'
                        }
                        //validacion para numero de telefono
                        if(!valores.tel) {
                            errores.tel = 'Por favor ingresa un número de teléfono';
                        }
                        return errores;
                        }
                    }
                    //para enviar el formulario
                    onSubmit={(valores, {resetForm}) => { 
                        resetForm(); //para limpiar los inputs
                        setFormEnviado(true)
                        setTimeout(() => 
                            setFormEnviado(false), 3000
                        )
                        /* aqui iria una llamada a una API */
                        const form = document.getElementById('form');
                        const formData = new FormData(form);
                        const mailTo = document.getElementById('mailTo');

                        mailTo.setAttribute('href', `mailto:rod.cond.fredy@gmail.com?subject=${formData.get('subject')}&body=${formData.get('message')}`);
                        mailTo.click();
                    }}
                >
                    {
                        //renderer prop
                        ({errors}) => (
                            <Form className='form' id='form'>
                                <div className='form__group'>
                                    <Field
                                        className='form__group__input'
                                        type='text' 
                                        id='name' 
                                        name='name' 
                                        placeholder=' '
                                    />
                                    <label className='form__group__label' htmlFor='name'>Nombre *</label>
                                    <ErrorMessage name='name' component={() => (
                                        <div className='form__group__error'>{errors.name}</div>
                                    )}/>
                                </div>
                                <div className='form__group'>
                                    <Field 
                                    className='form__group__input'
                                    type='email' 
                                    id='emal' 
                                    name='email' 
                                    placeholder=' '/>
                                    <label className='form__group__label' htmlFor='email'>Email *</label>
                                    <ErrorMessage name='email' component={() => (
                                        <div className='form__group__error'>{errors.email}</div>
                                    )}/>
                                </div>
                                <div className='form__group'>
                                    <Field
                                    className='form__group__input'
                                    type='tel' 
                                    id='tel' 
                                    name='tel' 
                                    placeholder=' '/>
                                    <label className='form__group__label' htmlFor='tel'>Número de teléfono *</label>
                                    <ErrorMessage name='tel' component={() => (
                                        <div className='form__group__error'>{errors.tel}</div>
                                    )}/>
                                </div>
                                <div className='form__group'>
                                    <Field
                                        className='form__group__input'
                                        type='text' 
                                        id='subject' 
                                        name='subject' 
                                        placeholder=' '
                                    />
                                    <label className='form__group__label' htmlFor='subject'>Asunto</label>
                                </div>
                                <div className='form__group'>
                                    <Field
                                    className='form__group__input'
                                    as='textarea' 
                                    rows='4'
                                    id='message' 
                                    name='message' 
                                    placeholder=' '/>
                                    <label className='form__group__label' htmlFor='message'>Mensaje</label>
                                </div>
                                <a href='mailto:rod.cond.fredy@gmail.com' id='mailTo' className='form__button'>
                                    <button type='submit'>Enviar</button>
                                </a>
                                {
                                    formEnviado && <p>Formulario enviado con exito</p>
                                }
                            </Form>
                        )
                    } 
                    {/* {
                        //renderer prop
                        //handleSubmit, handlechange y handleblur son funciones de Formik
                        ({values, errors, touched, handleSubmit, handleChange, handleBlur}) => (
                            <form className='form' onSubmit={handleSubmit}>
                                <div className='form__group'>
                                    <label htmlFor='name'>Nombre</label>
                                    <input 
                                    type='text' 
                                    id='name' 
                                    name='name' 
                                    placeholder='Nombre'
                                    value={values.name} //viene de initialValues
                                    onChange={handleChange} //para que se envie la informacion
                                    onBlur={handleBlur}/> //para validar el campo al hacer click fuera del input
                                    {touched.name && errors.name && <div className='form__group__error'>{errors.name}</div>}
                                </div>
                                <div className='form__group'>
                                    <label htmlFor='email'>Email</label>
                                    <input 
                                    type='email' 
                                    id='emal' 
                                    name='email' 
                                    placeholder='correo@ejemplo.com'
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}/>
                                    {touched.email && errors.email && <div className='form__group__error'>{errors.email}</div>}
                                </div>
                                <div className='form__group'>
                                    <label htmlFor='tel'>Número de teléfono</label>
                                    <input 
                                    type='tel' 
                                    id='tel' 
                                    name='tel' 
                                    placeholder='Número telefónico'
                                    value={values.tel}
                                    onChange={handleChange}
                                    onBlur={handleBlur}/>
                                </div>
                                <div className='form__group'>
                                    <label htmlFor='asunto'>Asunto</label>
                                    <input 
                                    type='text' 
                                    id='asunto' 
                                    name='asunto' 
                                    placeholder='Asunto'
                                    value={values.asunto}
                                    onChange={handleChange}
                                    onBlur={handleBlur}/>
                                </div>
                                <button type='submit'>Enviar</button>
                                {
                                    formEnviado && <p>Formulario enviado con exito</p>
                                }
                            </form>
                        )
                    }  */}
                </Formik>
                <div className='page-contact__form__image'>
                    <img src='./assets/images/page-contact-background.svg' alt='persona enviando un mensaje'/>
                </div>
            </div>
        </div>
    )
}

export default PageContact;